"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '&:nth-child(even)': {
        backgroundColor: function backgroundColor(props) {
          return props.zebra ? theme.palette.neutral.iceberg : 'inherit';
        }
      },
      '&$selected': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.denim[100], 0.5)
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.denim[100]
      }
    },
    hover: {},
    selected: {}
  };
}, {
  name: 'pds-table__row'
});

exports.default = _default;
